// Global impersonation state
// This allows the queryClient to access the impersonated user ID for all API calls

let impersonatedUserId: string | null = null;

export function setImpersonatedUser(userId: string | null) {
  impersonatedUserId = userId;
}

// Global setter registry — lets components deep in the tree trigger impersonation
// without prop-drilling through AuthenticatedRouter.
let _globalViewAsSetter: ((id: string) => void) | null = null;

export function registerViewAsSetter(fn: (id: string) => void) {
  _globalViewAsSetter = fn;
}

export function triggerViewAs(userId: string) {
  _globalViewAsSetter?.(userId);
}

export function getImpersonatedUser(): string | null {
  return impersonatedUserId;
}

export function getImpersonationHeaders(): Record<string, string> {
  if (impersonatedUserId) {
    return { "X-View-As-UserId": impersonatedUserId };
  }
  return {};
}
